// @ts-ignore

export interface IConfirmationDialog {
    onSuccess: () => void;
    headerText: string;
    bodyText: string;
    onDialogClose: () => void;
    message: any
}

function ConfirmationPopup(props: IConfirmationDialog) {
    const {headerText, bodyText, message} = props;
    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal align-middle modal-sisfs d-block">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-body text-center">

                            <h3 className="modal-message">{headerText}</h3>
                            <div className="modal-text">{bodyText}</div>
                            <div className="modal-action">

                                <button className="btn btn-sisfs btn-yellow-primary" onClick={props.onSuccess}>
                                    Continue
                                </button>

                                <button className="btn btn-default" data-dismiss="modal" onClick={props.onDialogClose}>
                                    Cancel
                                </button>
                            </div>


                            {message.result && message.message &&
                            <p className="alert alert-success text-success">
                                {message.message}
                            </p>
                            }
                            {!message.result && message.message &&
                            <p className="alert alert-danger text-danger">
                                {message.message}
                            </p>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

// @ts-ignore
export default ConfirmationPopup;
